// Format timestamps in India Standard Time (Asia/Kolkata, UTC+5:30)
// so the whole team sees consistent times regardless of their browser tz.

const IST = "Asia/Kolkata";

const dateFmt = new Intl.DateTimeFormat("en-IN", {
  timeZone: IST,
  day: "2-digit",
  month: "short",
});

const timeFmt = new Intl.DateTimeFormat("en-IN", {
  timeZone: IST,
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

const dateTimeFmt = new Intl.DateTimeFormat("en-IN", {
  timeZone: IST,
  day: "2-digit",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export function formatISTDateTime(iso) {
  if (!iso) return "";
  try {
    return `${dateTimeFmt.format(new Date(iso))} IST`;
  } catch {
    return "";
  }
}

export function formatISTTime(iso) {
  if (!iso) return "";
  try {
    return timeFmt.format(new Date(iso));
  } catch {
    return "";
  }
}

export function formatISTDate(iso) {
  if (!iso) return "";
  try {
    return dateFmt.format(new Date(iso));
  } catch {
    return "";
  }
}
